/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorAuctionDetailDto } from '../../models/vendor-auction-detail-dto';

export interface ApiVendorVendorAuctionSaveBiddingPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorAuctionDetailDto
}

export function apiVendorVendorAuctionSaveBiddingPost(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionSaveBiddingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorAuctionDetailDto>> {
  const rb = new RequestBuilder(rootUrl, apiVendorVendorAuctionSaveBiddingPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorAuctionDetailDto>;
    })
  );
}

apiVendorVendorAuctionSaveBiddingPost.PATH = '/api/vendor/vendor-auction/SaveBidding';
